import styled from "styled-components";
import moment from "moment-timezone";
import { RATypography } from "@/components/customs";
import { Row, Col, Skeleton } from "antd";
import { lightTheme } from "@/themes/ThemeConfig";
import { AirportLegInfo } from "../AirportLegInfo";
import { useSelector } from "react-redux";
import { selectFormatDateTimeDeparture } from "@/stores/slices/authSlice";

export function CharterDetailLegInfo({ legs = [] }) {
	const formatDTDeparture = useSelector(selectFormatDateTimeDeparture);
	const _renderLegItem = (data = {}) => {
		const { departure_window, departure, from_airport, to_airport } = data;
		const _renderDepartTime = () => {
			if (departure_window) {
				return (
					<Row align="middle" gutter={[4, 4]} justify="center" style={{ height: "100%" }}>
						<Col span={24}>
							<RATypography variant="body4" color="#595959">
								Departure window
							</RATypography>
						</Col>
						<Col span={24}>
							<Row gutter={[6, 6]}>
								<Col style={{ minWidth: "32px" }}>
									<RATypography variant="body4" color="#595959">
										From
									</RATypography>
								</Col>
								<Col>
									<RATypography variant="sub-heading4" color={lightTheme.color_text_500}>
										{departure
											? moment(departure?.utc_datetime)
													.tz(from_airport?.location?.timezone)
													.format(formatDTDeparture)
											: "TBD"}
									</RATypography>
								</Col>
							</Row>
						</Col>
						<Col span={24}>
							<Row gutter={[6, 6]}>
								<Col style={{ minWidth: "32px" }}>
									<RATypography variant="body4" color="#595959">
										To
									</RATypography>
								</Col>
								<Col>
									<RATypography variant="sub-heading4" color={lightTheme.color_text_500}>
										{departure_window
											? moment(departure_window?.utc_datetime)
													.tz(from_airport?.location?.timezone)
													.format(formatDTDeparture)
											: "TBD"}
									</RATypography>
								</Col>
							</Row>
						</Col>
					</Row>
				);
			}

			return (
				<Row align="middle" gutter={16}>
					<Col>
						<RATypography variant="body4" color="#595959">
							Departure time
						</RATypography>
					</Col>
					<Col>
						<RATypography variant="sub-heading4" color={lightTheme.color_text_500}>
							{departure
								? moment(departure?.utc_datetime)
										.tz(from_airport?.location?.timezone)
										.format(formatDTDeparture)
								: "TBD"}
						</RATypography>
					</Col>
				</Row>
			);
		};
		return (
			<WrapperLegItem>
				<Row gutter={[20, 20]} style={{ width: "100%" }}>
					<Col xl={17} lg={16} md={24} sm={24} xs={24}>
						<AirportLegInfo from_airport={from_airport} to_airport={to_airport} />
					</Col>
					<Col
						xl={7}
						lg={8}
						md={24}
						sm={24}
						xs={24}
						style={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
						}}
					>
						{_renderDepartTime()}
					</Col>
				</Row>
			</WrapperLegItem>
		);
	};
	return (
		<Container>
			{legs?.length > 0 ? legs.map((item, index) => <div key={index}>{_renderLegItem(item)}</div>) : <Skeleton />}
		</Container>
	);
}

const Container = styled.div`
	width: "100%";
	border-top: 1px solid #e9e8e8;
	border-radius: 0px 0px 12px 0px;
	background-color: #ffffff;
	@media (max-width: 768px) {
		border: none;
		border-radius: 0px 0px 12px 12px;
	}
`;
const WrapperLegItem = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 24px;
	border-radius: 0px 0px 8px 0px;
	@media (max-width: 1024px) {
		padding: 16px;
	}
	@media (max-width: 768px) {
		border: none;
		border-radius: 0px 0px 12px 12px;
	}
`;
